module.exports = __webpack_public_path__ + "static/media/goat1.36d08ac8.gif";